// // Helper to recursively get all files from DataTransfer items
// export const getFilesFromDataTransfer = async (dataTransfer) => {
//   const files = [];
//   const items = dataTransfer.items;

//   const traverseFileTree = async (entry, path = "") => {
//     if (entry.isFile) {
//       const fileEntry = entry;
//       return new Promise((resolve) => {
//         fileEntry.file((file) => {
//           // Optionally preserve relative path
//           // file.webkitRelativePath = path + file.name;
//           files.push(file);
//           resolve();
//         });
//       });
//     } else if (entry.isDirectory) {
//       const dirEntry = entry;
//       const reader = dirEntry.createReader();
//       return new Promise((resolve) => {
//         reader.readEntries(async (entries) => {
//           for (const childEntry of entries) {
//             await traverseFileTree(childEntry, `${path}${dirEntry.name}/`);
//           }
//           resolve();
//         });
//       });
//     }
//   };

//   for (let i = 0; i < items.length; i++) {
//     const entry = items[i].webkitGetAsEntry();
//     if (entry) {
//       await traverseFileTree(entry);
//     } else {
//       // Fallback for plain files (shouldn't happen with modern browsers)
//       const file = items[i].getAsFile();
//       if (file) files.push(file);
//     }
//   }

//   return files;
// };

export const getFilesFromDataTransfer = async (dataTransfer) => {
  const files = [];

  const items = Array.from(dataTransfer.items || []);

  const traverseFileTree = (entry) => {
    return new Promise((resolve) => {
      if (entry.isFile) {
        entry.file((file) => {
          files.push(file);

          resolve();
        });

        return;
      }

      if (entry.isDirectory) {
        const dirReader = entry.createReader();

        const entries = [];

        const readEntries = () => {
          dirReader.readEntries(async (results) => {
            if (!results.length) {
              // process all child entries
              await Promise.all(
                entries.map((childEntry) => traverseFileTree(childEntry)),
              );

              resolve();

              return;
            }

            entries.push(...results);

            readEntries();
          });
        };

        readEntries();

        return;
      }

      resolve();
    });
  };

  await Promise.all(
    items.map(async (item) => {
      const entry = item.webkitGetAsEntry?.();

      if (entry) {
        await traverseFileTree(entry);
      } else {
        const file = item.getAsFile?.();

        if (file) {
          files.push(file);
        }
      }
    }),
  );

  return files;
};
